import type { ComponentProps } from "react";

import logoSrc from "@/assets/veltro-logo.svg";
import { cn } from "@/shared/utils/cn";

type VeltroLogoProps = Omit<ComponentProps<"img">, "src">;

export function VeltroLogo({
  alt = "Veltro logo",
  className,
  ...props
}: VeltroLogoProps) {
  return (
    <img
      src={logoSrc}
      alt={alt}
      className={cn("block shrink-0", className)}
      {...props}
    />
  );
}
